import { Injectable } from '@angular/core';

@Injectable()
export abstract class ChartDefinitionBase {

	constructor() {
	}
}
